import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from '../common/primitives.js';
/**
 * Server-sent invalidation hints. They carry identifiers only: clients refetch through the normal
 * authorized endpoints, so a hint can never leak restricted content.
 */
export const REALTIME_EVENT_TYPES = [
    'topic.changed',
    'discussion.changed',
    'round.changed',
    'decision.changed',
    'notification.created',
    'task.changed',
    'update.changed',
    'meeting.changed',
    'goal.changed',
];
export const realtimeEventTypeSchema = z.enum(REALTIME_EVENT_TYPES);
export const realtimeEventSchema = z.object({
    type: realtimeEventTypeSchema,
    workspaceId: uuidSchema,
    topicId: uuidSchema.nullable(),
    entityId: uuidSchema.nullable(),
    at: isoDateTimeSchema,
});
/** SSE event name used for every hint; keep-alive comments are sent between events. */
export const REALTIME_SSE_EVENT = 'mfos';
//# sourceMappingURL=realtime.js.map